import { useTranslation } from 'next-i18next'

import FAQItem from '~/start/components/FAQItem'
import { faqData as defaultFaqData } from '~/start/constants'

export interface FAQDataItem {
  questionKey: string
  answerKey: string
}

export interface FAQProps {
  faqData?: Array<FAQDataItem | null>
  titleKey?: string
  descriptionKey?: string
  translationNamespace?: string
  translationPrefix?: string
  isSubscriptionFAQ?: boolean
  isLandingPageFAQ?: boolean
  isLandingPageV2FAQ?: boolean
  className?: string
  hideTitleAndDescription?: boolean
}

export default function FAQ({
  faqData = defaultFaqData,
  titleKey = 'FAQ.title',
  descriptionKey = 'FAQ.description',
  translationNamespace = 'start',
  translationPrefix = 'FAQ.',
  isSubscriptionFAQ = false,
  isLandingPageFAQ = false,
  isLandingPageV2FAQ = false,
  className = '',
  hideTitleAndDescription = false,
}: FAQProps): React.ReactElement {
  const { t } = useTranslation(translationNamespace)

  return (
    <div
      className={`flex flex-col justify-center text-white w-full max-w-232 mx-auto ${
        isSubscriptionFAQ ? 'gap-2' : 'gap-8 p-4'
      } ${className}`}
    >
      {!hideTitleAndDescription && (
        <>
          <h3
            className={`${
              isLandingPageV2FAQ ? 'text-6 md:text-10' : 'uppercase text-7 md:text-h2 leading-12 md:leading-14.5'
            } ${isSubscriptionFAQ ? 'font-black' : 'text-center'} font-bold`}
          >
            {t(titleKey)}
          </h3>
          <p
            className={`max-w-4xl mx-auto text-center ${
              isLandingPageFAQ ? 'text-blue-pastel text-md px-2' : 'text-md md:text-m-lg'
            }`}
          >
            {t(descriptionKey)}
          </p>
        </>
      )}
      <div className="flex flex-col gap-4">
        {faqData.map(
          (data) =>
            data && (
              <FAQItem
                answerKey={data.answerKey}
                isSubscriptionFAQ={isSubscriptionFAQ}
                key={data.questionKey}
                questionKey={data.questionKey}
                translationNamespace={translationNamespace}
                translationPrefix={translationPrefix}
              />
            ),
        )}
      </div>
    </div>
  )
}
